module.exports = __webpack_public_path__ + "static/media/p208vid2.053dda7a.mp4";